import { createApp } from 'vue';
import GiftMenu from '../../components/gifts/menu.vue';

document.addEventListener('DOMContentLoaded', () => {
	let templates = document.querySelectorAll("[data-vue='gift-purchase-menu']");
	for (let el of templates) {
		const initialData = JSON.parse(el.getAttribute('data'));
		const app = createApp(GiftMenu, {
			selectedUser: initialData['selectedUser']
		});
		app.mount(el);
	}
});
